// extracted by mini-css-extract-plugin
module.exports = {"noteLimitAlert":"MaxNotesLimit_noteLimitAlert__yI5zt"};